import { Badge, Stack } from '@mui/joy';

import { Color, Direction, Size } from 'theme/enums';

import { IBadgeItem } from './types';

interface IProps {
  items: IBadgeItem[];
}

export const Badges = ({ items }: IProps) => {
  return (
    <Stack direction={Direction.ROW} spacing={1.25} sx={{ position: 'absolute', top: 0, right: 3 }}>
      {items.map((badge: IBadgeItem, index: number) => (
        <Badge
          key={index + badge.key}
          color={badge?.color || Color.PRIMARY}
          size={badge?.size || Size.SM}
        />
      ))}
    </Stack>
  );
};
